import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';
import { getApplicationData } from 'selectors/getApplicationData';
import { getReferralLinkState } from 'selectors/getReferralLink';
import { getReferralLink } from 'thunks';
import { copyToClipboard } from 'utils/copyToClipboard';
import { ReactComponent as CopyIcon } from 'images/copy-icon.svg';

import styles from './ReferralSection.module.scss';

const REFERRAL_TERMS_URL = 'https://www.planneryapp.com/referral-terms';

const ReferralSection: React.FC = () => {
  const dispatch = useDispatch();
  const { application } = useSelector(getApplicationData);
  const { referralLink, isLoading } = useSelector(getReferralLinkState);

  useEffect(() => {
    if (!application?.id) return;

    dispatch(getReferralLink(application.id));
  }, [application?.id, dispatch]);

  if (isLoading || !referralLink) return null;

  const handleCopyLink = () => {
    copyToClipboard(referralLink);
    analytics.track('Dashboard Referral Copy Link Clicked');
  };

  return (
    <div className={styles.referralSection}>
      <ActionCard variant={ActionCardVariant.Referral}>
        <ActionCard.Title className={styles.title}>
          Share Plannery and earn $5 for every friend who signs up.
        </ActionCard.Title>

        <ActionCard.Description className={styles.description}>
          Help your healthcare friends and colleagues achieve their financial goals. For every person who signs up{' '}
          <strong>you get $5 and they get $5</strong>. Terms apply.
        </ActionCard.Description>

        <button type="button" className={styles.copyLink} onClick={handleCopyLink}>
          <span className={styles.linkText}>{referralLink}</span>
          <CopyIcon className={styles.copyIcon} aria-hidden />
        </button>

        <p className={styles.termsText}>
          By sharing this link you agree to abide by the{' '}
          <a href={REFERRAL_TERMS_URL} target="_blank" rel="noreferrer">
            terms and conditions
          </a>{' '}
          of this program
        </p>
      </ActionCard>
    </div>
  );
};

export default ReferralSection;
